const state = {
    encodedFilters: null,
    isContentLoading: false
};

const getters = {
    encodedFilters: state => state.encodedFilters,
    isContentLoading: state => state.isContentLoading
};

const mutations = {
    setEncodedFilters: (state, data) => state.encodedFilters = data,
    setIsContentLoading: (state, data) => state.isContentLoading = data
};

const actions = {
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};